import { ApprovalConsultResponseInterface } from '../../../interfaces/response/approval-consult/approval-consult-response-interface';

export class CpApprovalConsultResponseModel implements ApprovalConsultResponseInterface {
  appointmentId: number = -1;
  appointmentStatus: string = '';

  constructor(init?: Partial<CpApprovalConsultResponseModel>) {
    Object.assign(this, init);
  }
}
